module.exports = __webpack_public_path__ + "static/media/copylink.1e732e17.svg";